import {
  Add_DIAGNOSIS_PRESCRIPTION,
  Add_EXAMINATION_PRESCRIPTION,
  Add_INSTRUCTION_PRESCRIPTION,
  Add_INVESTIGATION_PRESCRIPTION,
  Add_MEDICAL_HISTORY_PRESCRIPTION,
  Add_MEDICATION_PRESCRIPTION,
  Add_SYMPTOM_PRESCRIPTION,
  LOAD_TEMPLATE_IN_MANAGE_PRECRIPTION,
  TOGGLE_SELECT_DIAGNOSIS_PRESCRIPTION,
  TOGGLE_SELECT_EXAMONATION_PRESCRIPTION,
  TOGGLE_SELECT_INSTRUCTION_PRESCRIPTION,
  TOGGLE_SELECT_INVESTIGATION_PRESCRIPTION,
  TOGGLE_SELECT_MEDICAL_HISTORY_PRESCRIPTION,
  TOGGLE_SELECT_MEDICATION_PRESCRIPTION,
  TOGGLE_SELECT_SYMPTOM_PRESCRIPTION,
  UPDATE_MANAGE_PRE_SUBMISSION_DATA,
} from "./type";

export const updateManagePrescriptionSubmissionData = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_MANAGE_PRE_SUBMISSION_DATA,
    payload: data,
  });
};

export const ManageDataInPrescription =
  ({ context, item, payload, existing, initial }) =>
  (dispatch) => {
    //Context should be Add, Toggle, Update

    let types = {
      symptom: {
        ADD: Add_SYMPTOM_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_SYMPTOM_PRESCRIPTION,
      },
      medical: {
        ADD: Add_MEDICAL_HISTORY_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_MEDICAL_HISTORY_PRESCRIPTION,
      },
      examination: {
        ADD: Add_EXAMINATION_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_EXAMONATION_PRESCRIPTION,
      },
      diagnosis: {
        ADD: Add_DIAGNOSIS_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_DIAGNOSIS_PRESCRIPTION,
      },
      investigation: {
        ADD: Add_INVESTIGATION_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_INVESTIGATION_PRESCRIPTION,
      },
      instruction:{
        ADD: Add_INSTRUCTION_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_INSTRUCTION_PRESCRIPTION,
      },
      medication:{
        ADD: Add_MEDICATION_PRESCRIPTION,
        TOGGLE: TOGGLE_SELECT_MEDICATION_PRESCRIPTION,
      }
    };

    console.log({
      action: types[item],
      context: context,
      payload,
      existing,
    });

    if (context === "Add") {
      let result = [...existing];
      result.push(payload);
      dispatch({
        type: types[item].ADD,
        payload: result,
      });
    }

    if (context === "Toggle") {
      let result = [...existing];
      let isSelected = existing.filter((each) => each.name === payload?.name);

      if (isSelected && isSelected.length > 0) {
        result = existing.filter((each) => each.name !== payload?.name);
        if (payload.isNew) {
          removeItem();
        }
      } else {
        result.push(payload);
      }

      dispatch({
        type: types[item].TOGGLE,
        payload: result,
      });
    }

    function  removeItem() {

      console.log("Removing item......................");
      let _initial = [...initial];
      _initial = _initial.filter((e) => e.name !== payload?.name);

      dispatch({
        type: types[item].ADD,
        payload: _initial,
      });
    }
  };

export const ManageInvestigationInPrescription =
  ({ context, payload, existing }) =>
  (dispatch) => {
    //Context should be Add, Toggle, Update

    if (context === "Add") {
      let result = [...existing];
      result.push(payload);

      dispatch({
        type: Add_INVESTIGATION_PRESCRIPTION,
        payload: result,
      });
    }

    if (context === "Toggle") {
      toggleData();
    }

    function toggleData() {
      let result = existing && existing.length > 0 ? [...existing] : [];
      let isSelected = existing.filter((each) => each.name === payload);

      if (isSelected && isSelected.length > 0) {
        result = existing.filter((each) => each.name !== payload);
      } else {
        result.push({ name: payload });
      }

      dispatch({
        type: TOGGLE_SELECT_INVESTIGATION_PRESCRIPTION,
        payload: result,
      });
    }
  };

export const ManageInstructionInPrescription =
  ({ context, payload, existing }) =>
  (dispatch) => {
    //Context should be Add, Toggle, Update

    if (context === "Add") {
      let result = [...existing];
      result.push(payload);

      dispatch({
        type: Add_INSTRUCTION_PRESCRIPTION,
        payload: result,
      });
    }

    if (context === "Toggle") {
      toggleData();
    }

    function toggleData() {
      let result = existing && existing.length > 0 ? [...existing] : [];
      let isSelected = existing.filter((each) => each.name === payload);

      if (isSelected && isSelected.length > 0) {
        result = existing.filter((each) => each.name !== payload);
      } else {
        result.push({ name: payload });
      }

      dispatch({
        type: TOGGLE_SELECT_INSTRUCTION_PRESCRIPTION,
        payload: result,
      });
    }
  };

export const ManageMedicationInPrescription =
  ({ context, payload, existing }) =>
  (dispatch) => {
    //Context should be Add, Toggle, Update

    if (context === "Add") {
      let result = [...existing];
      result.push(payload);

      dispatch({
        type: Add_MEDICATION_PRESCRIPTION,
        payload: result,
      });
    }

    if (context === "Toggle") {
      toggleData();
    }

    function toggleData() {
      let result = existing && existing.length > 0 ? [...existing] : [];
      let isSelected = existing.filter((each) => each.name === payload);

      if (isSelected && isSelected.length > 0) {
        result = existing.filter((each) => each.name !== payload);
      } else {
        result.push({ name: payload });
      }

      dispatch({
        type: TOGGLE_SELECT_MEDICATION_PRESCRIPTION,
        payload: result,
      });
    }
  };

export const loadTemplateToDetailsTab = (data) => (dispatch) => {
  let {
    patientDetails,
    consultationNotes,
    treatmentAdvice,
    followup,
    referral,
  } = data;

  let submissionData = {};

  if (data) {
    if (patientDetails) {
      submissionData = { ...submissionData, ...data.patientDetails };
    }
    if (consultationNotes) {
      submissionData.symptoms = consultationNotes.symptoms;
      submissionData.medicalHistory = consultationNotes.medicalHistory;
      submissionData.medical_history_note =
        consultationNotes.medical_history_note;
      submissionData.examinations = consultationNotes.examinations;
      submissionData.diagnosis = consultationNotes.diagnosis;

      submissionData.vaccinationStatus = consultationNotes.vaccinationStatus;
      submissionData.vaccinationDoseCount =
        consultationNotes.vaccinationDoseCount;
      if (
        consultationNotes.vaccinationNames &&
        consultationNotes.vaccinationNames.length > 0
      ) {
        consultationNotes.vaccinationNames.map((each, key) => {
          console.log("Mapping.....");

          submissionData[`vaccinationName${key + 1}`] = each;
        });
      }
    }
    if (treatmentAdvice) {
      submissionData.investigations = treatmentAdvice.investigations;
      submissionData.instructions = treatmentAdvice.instructions;
      submissionData.medications = treatmentAdvice.medications;
      submissionData.reports = treatmentAdvice.reports;
      submissionData.attachedReportFiles = treatmentAdvice.attachedReportFiles;
    }
    if (followup && followup.followup_date) {
      submissionData.followup_date = { ...followup.followup_date };
    }
    if (referral) {
      submissionData = { ...submissionData, ...referral };
    }
  }

  dispatch({
    type: LOAD_TEMPLATE_IN_MANAGE_PRECRIPTION,
    payload: submissionData,
  });
};
